import { Button } from "antd";
import { ManageAffiliateForm } from "components/Forms/ManageAffiliateForm/ManageAffiliateForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC, useState } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddAffiliateDrawerProps {
    onSuccess?: () => void;
}

export const AddAffiliateDrawer: FC<AddAffiliateDrawerProps> = (props) => {
    const { t } = usePaldockTranslation("drawers.add-affiliate");
    const { t: tCommon } = usePaldockTranslation("common");
    const id = DrawerId.AddAffiliate;
    const [canSubmit, setCanSubmit] = useState(false);

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button
                    size={"large"}
                    htmlType="submit"
                    type={"primary"}
                    form={FormId.AddUserForm}
                    disabled={!canSubmit}
                >
                    {tCommon("create")}
                </Button>
            }
        >
            <DrawerContent>
                <ManageAffiliateForm onSuccess={props.onSuccess} onCanSubmitChange={setCanSubmit} mode="create" />
            </DrawerContent>
        </Drawer>
    );
};
